import {CampaignVersionStatus} from 'common/src/modules/campaigns/campaigns.types';
import getVersionData from 'common/src/modules/campaigns/utils/getVersionData';
import {CampaignStep} from 'common/src/modules/campaignWorkflow/campaignWorkflow.enums';
import {DTVersion} from 'common/src/modules/decisionTree/decisionTree.types';
import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import {RouteWithParams} from 'common/src/modules/routing/routing.types';
import getCurrentRouteWithParams from 'common/src/modules/routing/utils/getCurrentRouteWithParams';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {CampaignSetupAgentToolName} from '../../../campaignSetupAgent.enums';

const inputSchema = z.object({
  campaignId: z.string(),
});

function verifyCampaignPathTool(step: CampaignStep, store: CLStore) {
  async function execute({input, toolUtils}: ToolExecuteParams<typeof inputSchema>) {
    const {campaignId} = input;

    toolUtils.logger.log(
      'inputs:\n',
      {campaignId},
      '\nwindow.location.pathname:\n',
      window.location.pathname,
    );

    if (!routingService.isMatchRoute(Routes.CampaignPage, window.location.pathname)) {
      return toolResult(
        'The user is not on a campaign page. Ask him if he wants to navigate to the campaign page, or create a new campaign?',
      );
    }

    const routeWithParams = getCurrentRouteWithParams() as RouteWithParams;

    toolUtils.logger.log('routeWithParams:', routeWithParams);

    const {queryParamValues, pathParamValues} = routeWithParams;
    const steps = queryParamValues.steps as CampaignStep[];

    if (+pathParamValues.campaignId !== +campaignId) {
      return toolResult(
        `The user is not on the campaign page ${campaignId}. Ask him if he wants to navigate to the campaign page, or create a new campaign?`,
      );
    }

    if (!steps || !steps.includes(step)) {
      return toolResult(
        `The user is not on the ${step} page. Ask him if he wants to be navigated to it.`,
      );
    }

    const state = store.getState();
    const versionNumber = state.campaignPage.campaignTree.versionNumber;
    const campaignVersions = state.campaignPage.campaignTree.campaignVersions;

    if (versionNumber !== null && campaignVersions.length > 0) {
      const currentVersion = campaignVersions.find((v: DTVersion) => v.number === versionNumber);

      if (currentVersion) {
        const versionData = getVersionData(currentVersion);

        toolUtils.logger.log('currentVersion:', currentVersion, 'versionData:', versionData);

        if (versionData.status !== CampaignVersionStatus.Draft) {
          return toolResult(
            `The user is currently viewing a ${versionData.status} version. Changes can only be made to Draft versions. Please inform the user that they need to be on a Draft version to make changes.`,
          );
        }
      }
    }

    return toolResult('Good to go');
  }

  return tool({
    name: CampaignSetupAgentToolName.VerifyCampaignPath,
    displayName: 'Verifying Current Path',
    description: `Verify that the user is on the ${step} page`,
    inputSchema,
    execute,
    isReadonly: true,
  });
}

export default verifyCampaignPathTool;
